import Alert from '@mui/material/Alert';
import styles from './styles.module.scss';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { RotatingLines } from 'react-loader-spinner';
import { useState } from 'react';
import userServices from '@/api/userServices';
import { selectUsers, setCheckCBS } from '@/features/user/userSlice';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { CbsNotif } from './CbsNotif';
import { styled } from '@mui/material/styles';

const StyledAlert = styled(Alert)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& .MuiAlert-action': {
    marginLeft: 0,
  },
  backgroundColor: 'var(--system-color-orange)',
  '& .MuiSvgIcon-root': {
    fill: '#060318',
  },
  '& .MuiSvgIcon-root>path': {
    scale: '.95!important',
  },
});

const CbsNotification = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [cbsStatus, setCbsStatus] = useState('');
  const dispatch = useAppDispatch();
  const { cbsStatus: storedCbsStatus, billingError } = useAppSelector(selectUsers);
  const isCbsDown = storedCbsStatus !== 'UP';
  const isBillNotFound = billingError === 'bill_not_found';

  const handleCheckStatus = () => {
    setLoading(true);
    userServices
      .getCBSStatus()
      .then(resp => {
        const status = resp.status;
        setCbsStatus(status);
      })
      .finally(() => setLoading(false));
  };

  const modalTitle = () => {
    if (cbsStatus === 'UP') {
      return 'userProfile.cbsAvailable';
    } else {
      return 'userProfile.cbsUnavailable';
    }
  };

  const modalSubTitle = () => {
    if (cbsStatus === 'UP') {
      return 'userProfile.cbsAvailableDes';
    } else {
      return 'userProfile.cbsUnavailableDes';
    }
  };

  const onCloseModal = () => {
    if (cbsStatus === 'UP') {
      return () => {
        dispatch(setCheckCBS(cbsStatus));
        setCbsStatus('');
      };
    } else {
      return () => {
        setCbsStatus('');
      };
    }
  };

  if (!isCbsDown && !isBillNotFound) return null;

  return (
    <div>
      {cbsStatus && <CbsNotif onClose={onCloseModal()} title={modalTitle()} subTitle={modalSubTitle()} />}
      <StyledAlert
        className={clsx('flex items-center justify-center mb-6', styles['warning'])}
        icon={<WarningAmberRoundedIcon className='!w-[32px] !h-[34px]' />}
        severity='warning'
      >
        <div className='flex items-center justify-between'>
          <p
            aria-label={isCbsDown ? 'cbs issue message' : 'bill not found message'}
            className={clsx('subtitle2s flex items-start justify-center max-w-[67.563rem] m-0', styles['warning'])}
          >
            {isCbsDown ? t('notification.cbsIssue') : t('notification.billNotFound')}
          </p>
          {isCbsDown && (
            <div className='ml-48 mr-4'>
              {loading ? (
                <RotatingLines strokeColor='black' strokeWidth='' animationDuration='0.75' width='24' visible={true} />
              ) : (
                <button onClick={handleCheckStatus}>
                  <p className='subtitle2 underline'>{t('notification.checkStatus')}</p>
                </button>
              )}
            </div>
          )}
        </div>
      </StyledAlert>
    </div>
  );
};

export default CbsNotification;
